import { render, staticRenderFns } from "./CustomViewSelector.vue?vue&type=template&id=51389450&scoped=true&"
import script from "./CustomViewSelector.vue?vue&type=script&lang=js&"
export * from "./CustomViewSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51389450",
  null
  
)

export default component.exports